<template>
<div class="center-page">
    <div class="personal-center container">
      <header class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <div class="header-text">
            <h2>个人学习中心</h2>
            <p>管理你的学习进度，开启编程之旅</p>
          </div>
        </div>
      </header>
  
      <section class="content-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-book"></i>
          </div>
          <h5>我的课程</h5>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(course, index) in courses"
            :key="'course-' + index"
          >
            <div class="course-card">
              <div class="card-header-custom">
                <div class="card-icon">
                  <i class="fas fa-laptop-code"></i>
                </div>
                <h5>{{ course.title }}</h5>
              </div>
              <div class="card-body-custom">
                <p class="card-desc">{{ course.description }}</p>
                <div class="card-actions">
                  <button v-if="index !== 2" class="btn-action btn-secondary-action" @click="enter('homework',index+1)">
                    <i class="fas fa-tasks"></i> 课后作业
                  </button>
                  <button class="btn-action btn-primary-action" @click="enter('classes',index+1)">
                    <i class="fas fa-play-circle"></i> 进入课堂
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="content-section">
        <div class="section-header">
          <div class="section-icon practice">
            <i class="fas fa-code"></i>
          </div>
          <h5>练习系统</h5>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(practice, index) in practices"
            :key="'practice-' + index"
          >
            <div class="practice-card">
              <div class="card-header-custom">
                <div class="card-icon" :class="getPracticeIconClass(index)">
                  <i :class="getPracticeIcon(index)"></i>
                </div>
                <h5>{{ practice.title }}</h5>
              </div>
              <div class="card-body-custom">
                <p class="card-desc">{{ practice.description }}</p>
                <div class="card-actions">
                  <button 
                    class="btn-action btn-primary-action"
                    @click="enter('exercises',index+1)"
                  >
                    <i class="fas fa-arrow-right"></i> 开始练习
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="content-section">
        <div class="section-header">
          <div class="section-icon exam">
            <i class="fas fa-trophy"></i>
          </div>
          <h5>模考系统</h5>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(exam, index) in exams"
            :key="'exam-' + index"
          >
            <div class="exam-card">
              <div class="card-header-custom">
                <div class="card-icon exam">
                  <i class="fas fa-file-alt"></i>
                </div>
                <h5>{{ exam.title }}</h5>
              </div>
              <div class="card-body-custom">
                <p class="card-desc">{{ exam.description }}</p>
                <div class="card-actions">
                  <button 
                    class="btn-action btn-primary-action"
                    @click="enter('exam',index+1)"
                  >
                    <i class="fas fa-pen"></i> 开始模考
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> 
    </div>
    <bottom></bottom>

    <div class="modal fade" id="realDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                  <i class="fas fa-list"></i> 选择题目
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div v-for="t in examSet" class="exam-group">
                <div class="exam-year">{{ t.year }}</div>
                <div class="exam-buttons">
                  <button @click="realExercise(t.year,q)" v-for="q in t.questions" class="exam-btn">{{ q }}</button>
                </div>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="practiceDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                  <i class="fas fa-list"></i> 选择模拟题目
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div v-for="t in practiceSet" class="exam-group">
                <div class="exam-year">{{ t.year }}</div>
                <div class="exam-buttons">
                  <button @click="realExercise(t.year,q)" v-for="q in t.questions" class="exam-btn">{{ q }}</button>
                </div>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="typeDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                  <i class="fas fa-tags"></i> 选择练习模块
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="tag-buttons">
                <button @click="tagExercise(t)" v-for="t in tags" class="tag-btn">{{ t.tag_name }}</button>
              </div>
              </div>
            </div>
        </div>
    </div>
</div>
  </template>
  
  <script>
  import bottom from '@/components/bottom.vue';
  export default {
    components: {
      bottom
    },
    data() {
      return {
        config:{

        },
        examSet:[
        {
            year:"2025",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2024",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2023",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2022",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2021",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2020",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          }
        ],
        practiceSet:[
          {
            year:"Series-1",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"Series-2",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
        ],
        tags:[],
        userName: "开发者小明",
        courses: [
          {
            title: "基础启航班",
            category: "",
            description: "学习Java语言的基础知识，基本算法",
            progress: 65
          },
          {
            title: "强化提高班",
            category: "",
            description: "学习编程知识的综合运用，助力AP",
            progress: 30
          },
          {
            title: "考前冲刺班",
            category: "",
            description: "面向AP考试重点题型，重点学习练习",
            progress: 80
          }
        ],
        practices: [
          
          {
            title: "每日一练",
            description: "精选题库，任意组题",
            status: "进行中",
            lastPractice: "",
            available: true
          },
          {
            title: "收藏突破",
            description: "错题，收藏题目反复练习突破",
            status: "未开通",
            lastPractice: "-",
            available: false
          },
          {
            title: "专项突破",
            description: "16大知识模块，分类突破",
            status: "已开通",
            lastPractice: "",
            available: true
          }
        ],
        exams: [
          {
            title: "真题模考",
            description: "往年真题，模拟考试",
            status: "已开通",
            lastPractice: "",
            available: true
          },
        ]
      };
    },
    mounted(){
        var user = localStorage.getItem('user');
        if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
            this.$http.get('https://programapi.dctechonline.cn/api/user/config/'+userObj.Mobile).then(res=>{
                this.config = res.data;
            })
        }
        else{
            location.href = '/';
        }
        this.$http.get('https://apapi.dctechonline.cn/api/tags').then(res=>{
          this.tags = res.data;
        })
    },
    methods: {
      getPracticeIcon(index) {
        const icons = ['fas fa-calendar-day', 'fas fa-star', 'fas fa-bullseye'];
        return icons[index] || 'fas fa-code';
      },
      getPracticeIconClass(index) {
        const classes = ['daily', 'favorite', 'target'];
        return classes[index] || '';
      },
      realExercise(year,q){
        $("#realDialog").modal("hide");
        $("#practiceDialog").modal("hide");
        if(q =='MCQ'){
          window.open('/real-mcq?year='+year+'&q='+q)
        
        }
        else{
          window.open('/real-frq?year='+year+'&q='+q)
        }
      },
      tagExercise(t){
        $("#typeDialog").modal("hide");
        this.$router.push('/exercises?id=3&tag='+t.tag_id);
      },
        enter(subject,index){
            var arr = this.config[subject];
            console.log(arr);

            if(subject == 'exercises' && index == 3){
              $("#typeDialog").modal("show");
              return;
            }

            if(subject=='exam' && index == 1){
              $("#realDialog").modal("show");
              return;
            }

            if(subject=='exam' && index == 2){
              $("#practiceDialog").modal("show");
              return;
            }

            if(subject == 'classes' && index == 3){
              window.open('/practice/index.html');
              return;
            }

            if(subject == 'homework' && index == 2){
              window.open('http://apcsa.dctechonline.cn');
              return;
            }



            this.$router.push('/'+subject+'?id='+index);

           
        },
        practiceStatusClass(practice) {
            return {
            'bg-success': practice.status === '已开通',
            'bg-warning': practice.status === '进行中',
            'bg-secondary': practice.status === '未开通'
            };
        }
    }
  };
  </script>
  
  <style lang="scss">
@import '@/styles/variables.scss';

.center-page {
  background: $bg-primary;
  min-height: 100vh;
}

.personal-center {
  padding-top: 100px;
  padding-bottom: 60px;
  min-height: 80vh;
}

.page-header {
  margin-bottom: 50px;
  
  .header-content {
    display: flex;
    align-items: center;
    gap: 20px;
    
    .header-icon {
      width: 60px;
      height: 60px;
      background: $primary-gradient;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 26px;
      box-shadow: $shadow-primary;
    }
    
    .header-text {
      h2 {
        font-size: 28px;
        font-weight: 700;
        color: $text-primary;
        margin: 0 0 4px 0;
      }
      
      p {
        font-size: 15px;
        color: $text-secondary;
        margin: 0;
      }
    }
  }
}

.content-section {
  margin-bottom: 50px;
  
  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid $border-light;
    
    .section-icon {
      width: 36px;
      height: 36px;
      background: linear-gradient(135deg, rgba($primary-color, 0.1) 0%, rgba($primary-light, 0.2) 100%);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $primary-color;
      font-size: 16px;
      
      &.practice {
        background: linear-gradient(135deg, rgba($secondary-color, 0.1) 0%, rgba($secondary-light, 0.2) 100%);
        color: $secondary-color;
      }
      
      &.exam {
        background: linear-gradient(135deg, rgba($accent-color, 0.1) 0%, rgba($accent-light, 0.2) 100%);
        color: $accent-color;
      }
    }
    
    h5 {
      font-size: 18px;
      font-weight: 600;
      color: $text-primary;
      margin: 0;
    }
  }
}

.course-card, .practice-card, .exam-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: $shadow-card;
  border: 1px solid $border-light;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    transform: translateY(-6px);
    box-shadow: $shadow-card-hover;
    border-color: rgba($primary-color, 0.2);
  }
  
  .card-header-custom {
    background: $bg-secondary;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    
    .card-icon {
      width: 48px;
      height: 48px;
      background: $primary-gradient;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 20px;
      
      &.daily {
        background: linear-gradient(135deg, $secondary-color 0%, $secondary-light 100%);
      }
      
      &.favorite {
        background: linear-gradient(135deg, $accent-color 0%, $accent-light 100%);
      }
      
      &.target {
        background: linear-gradient(135deg, $success-color 0%, #34d399 100%);
      }
      
      &.exam {
        background: linear-gradient(135deg, $info-color 0%, #60a5fa 100%);
      }
    }
    
    h5 {
      font-size: 17px;
      font-weight: 600;
      color: $text-primary;
      margin: 0;
    }
  }
  
  .card-body-custom {
    padding: 20px 24px;
    
    .card-desc {
      font-size: 14px;
      color: $text-secondary;
      margin-bottom: 20px;
      line-height: 1.6;
    }
    
    .card-actions {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
    }
  }
}

.btn-action {
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  
  i {
    font-size: 12px;
  }
  
  &.btn-primary-action {
    background: $primary-gradient;
    color: white;
    box-shadow: 0 4px 12px rgba($primary-color, 0.3);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba($primary-color, 0.4);
    }
  }
  
  &.btn-secondary-action {
    background: white;
    color: $primary-color;
    border: 1px solid $primary-color;
    
    &:hover {
      background: rgba($primary-color, 0.1);
    }
  }
}

.modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-header {
  background: $primary-gradient;
  color: white;
  border: none;
  padding: 20px 24px;
  
  .modal-title {
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
  }
  
  .close {
    color: white;
    opacity: 0.8;
    text-shadow: none;
    font-size: 28px;
    
    &:hover {
      opacity: 1;
    }
  }
}

.modal-body {
  padding: 24px;
  
  .exam-group {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .exam-year {
      font-weight: 600;
      color: $text-primary;
      margin-bottom: 12px;
      font-size: 15px;
    }
    
    .exam-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  }
  
  .exam-btn {
    background: white;
    border: 1px solid $border-color;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    color: $text-secondary;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 80px;
    
    &:hover {
      background: $primary-color;
      color: white;
      border-color: $primary-color;
    }
  }
  
  .tag-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .tag-btn {
    background: white;
    border: 1px solid $border-color;
    padding: 12px 20px;
    border-radius: 10px;
    font-size: 14px;
    color: $text-secondary;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: $primary-gradient;
      color: white;
      border-color: transparent;
      transform: translateY(-2px);
    }
  }
}

@media (max-width: 768px) {
  .page-header .header-content {
    flex-direction: column;
    text-align: center;
    
    .header-text {
      h2 {
        font-size: 24px;
      }
    }
  }
  
  .card-actions {
    flex-direction: column;
    
    .btn-action {
      width: 100%;
      justify-content: center;
    }
  }
}
  </style>
